import { Stack, Typography } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import parse from "html-react-parser";
import { Link as DomLink } from "react-router-dom";
export const FilterLabel = ({ filter, dispatch }) => {
  return (
    <Typography
      sx={{
        width: { xs: "20%", lg: "13%" },
        paddingTop: ".6rem",
        textTransform: "uppercase",
      }}
    >
      <Stack>
        {filter.name === "HooverPrice" ? (
          "Price"
        ) : (
          <Stack direction="row">
            {filter.label}
            {filter.label === "Source" || filter.label === "Features" ? (
              <DomLink to="/sub-landing/Diamond-Sources" target="_blank">
                <HelpIcon className="help-icon question-mark" />
              </DomLink>
            ) : (
              <HelpIcon
                className="help-icon question-mark"
                onClick={() =>
                  dispatch({
                    type: "setOpenHelpText",
                    payload: {
                      open: true,
                      label: filter.label,
                      text: parse(filter.help_text),
                    },
                  })
                }
              />
            )}
          </Stack>
        )}
      </Stack>
    </Typography>
  );
};
